import { getApiUrl } from "../../constants/pathConstants"
import { API_END_POINT_APP_REGISTER, API_END_POINT_INSTRUCTOR_REGISTER, API_END_POINT_REGISTER } from "../endPoints"

class RegisterConnector {
	requestInProgress: boolean = false

	public async performRegisterRequest(name: string, email: string, password: string, phoneNumber: string, dob: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [RegisterConnector] performRegisterRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let registerSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_REGISTER}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password,
						"name": name,
						"phoneNumber": phoneNumber,
						"dob": dob
					})
				})
					.then((res) => res.json())
					// .then((data: LoginResponse) => {
					.then((data) => {
						if (data.status === 'success') {
							// userStateData.userData = data.userData
							// userStateData.loggedIn = false
							// this.requestInProgress = false
							// return true
							registerSuccess = true
						} else {
							// this.requestInProgress = false
							// return false
							registerSuccess = false
						}
						// console.log('login data =', data)
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return registerSuccess // userStateData.loggedIn // true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[RegisterConnector] - performRegisterRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performInstructorRegisterRequest(name: string, email: string, password: string, school: number, gender: number, activity: number, phoneNumber: string, dob: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [RegisterConnector] performRegisterRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let registerSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_INSTRUCTOR_REGISTER}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password,
						"name": name,
						"phoneNumber": phoneNumber,
						"dob": dob,
						"school": school,
						"gender": `${gender}`,
						"activity": activity
					})
				})
					.then((res) => res.json())
					// .then((data: LoginResponse) => {
					.then((data) => {
						if (data.status === 'success') {
							// userStateData.userData = data.userData
							// userStateData.loggedIn = false
							// this.requestInProgress = false
							// return true
							registerSuccess = true
						} else {
							// this.requestInProgress = false
							// return false
							registerSuccess = false
						}
						// console.log('login data =', data)
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return registerSuccess // userStateData.loggedIn // true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[RegisterConnector] - performRegisterRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performAppRegisterRequest(name: string, email: string, password: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [RegisterConnector] performAppRegisterRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let registerSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_APP_REGISTER}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password,
						"name": name
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							registerSuccess = true
						} else {
							registerSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return registerSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[RegisterConnector] - performAppRegisterRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const registerConnector: RegisterConnector = new RegisterConnector()